<template>
  <div style="padding:0 30px 30px;">
    <div style="text-align:right;margin-bottom:10px"><Button size="small" @click="$router.go(-1)">返回</Button></div>
    <Row class="blockrow">
      <Col span="5" class="blockrow-4">
      <a @click="isshow = 0">
        考生和试卷信息&nbsp;
      </a>
      <Tree :data="dataLeft" :render="renderContent" @on-select-change="leftchange"
        style="padding: 0.4vh; overflow: hidden">
      </Tree>
      </Col>
      <Col span="19" class="blockrow-20" v-if="isshow == 1">
      <Row v-if="question_idobj.question_type">
        <Col span="24">
        <Table :columns="coloums" border :data="questiondata">
          <template slot-scope="{ row }" slot="answer">
            <span v-if="row.question.question_type.basic_ques_types == 11" v-html="row.answer"></span>
            <span v-else-if="row.answer < 7"> {{ String.fromCharCode(65 + Number(row.answer)) }}</span><span v-else>
              {{ row.answer }}</span>
          </template>
          <template slot-scope="{ row }" slot="student_answer">
            <span v-if="row.question.question_type.basic_ques_types == 11" v-html="row.student_answer"></span>
            <span v-else-if="row.student_answer && row.student_answer < 7"> {{ String.fromCharCode(65 +
              Number(row.student_answer)) }}</span><span v-else> {{ row.student_answer }}</span>
          </template>
          <template slot-scope="{ row }" slot="get_score">
            {{ row.get_score }}
            <!-- <Input-number class="umb" @on-change="changsore(row)" :max="Number(row.score)" :min="0" v-model="row.get_score"></Input-number> -->
          </template>
          <template slot-scope="{ row }" slot="is_right">
            <img :src="row.is_right == 2 ? right : erro" />
          </template>
        </Table>
        <Row class="e-list">
          <Col class="e-list-top">
          <div class="left">
            ID:<span>{{ question_idobj.id }}</span> 题型：<span>{{
              question_idobj.question_type.name
            }}</span>
            题库：<span>{{ question_idobj.storage_name }}</span>
            <!-- 年份：<span>2020</span> -->
          </div>
          <div class="right">
            <!-- rtrtt -->
          </div>
          </Col>
          <Col class="e-list-c" v-if="question_idobj.question_type.basic_ques_types == 5"><!-- 阅读理解选择题 -->
          <p class="e-list-c-b" v-html="question_idobj.formatData.stem_src_txt"></p>
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.sub_headings
          " v-html="question_idobj.formatData.sub_headings[0].sub_heading"></div>
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.sub_headings
          ">
            <p v-for="(option, i) in question_idobj.formatData
              .sub_headings[0].options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option" :style="{
                color:
                  question_idobj.formatData.sub_headings[0].answer
                    .answer == String.fromCharCode(65 + i)
                    ? '#e76f74'
                    : '',
              }"></p>
          </div>
          <div v-show="question_idobj.question_type.batch == 1 &&
            question_idobj.formatData.sub_headings
            " v-for="(see, se) in question_idobj.formatData.sub_headings" :key="se">
            <div class="e-list-c-c dis" v-html="se + 1 + '.' + see.sub_heading"></div>
            <div class="e-list-c-c">
              <p v-for="(option, i) in see.options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option"
                :style="{
                  color: see.answer.answer == i ? '#e76f74' : '',
                }"></p>
            </div>
          </div>
          </Col>
          <!-- 填空题 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 2">
          <div class="e-list-c-x">
            <p v-html="question_idobj.formatData.stem"></p>
          </div>
          <div class="e-list-c-x" v-if="question_idobj.formatData.answer">
            <span>答案：</span>
            <p v-html="question_idobj.formatData.answer[0].answer"></p>
          </div>
          </Col>
          <!-- n选n选择题 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 7">
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.stem
          " v-html="question_idobj.formatData.stem"></div>
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.options
          ">
            <p v-for="(option, i) in question_idobj.formatData.options" :key="i"
              v-html="String.fromCharCode(65 + i) + '.' + option.option" :style="{
                color:
                  question_idobj.formatData.answer.answer == i
                    ? '#e76f74'
                    : '',
              }"></p>
            <div class="e-list-c-x" v-if="question_idobj.formatData.answer">
              <span>答案：</span>
              <strong v-for="(is, iiis) in question_idobj.formatData.answer" :key="iiis">{{ is.answer }}</strong>
            </div>
          </div>
          </Col>
          <!-- 听写填空 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 4">
          <div v-if="question_idobj.formatData && question_idobj.formatData.stem_src_audio">
            <audio style="width: 180px; height: 30px" :ref="'audios'" controls
              :src="question_idobj.formatData.stem_src_audio"></audio>
          </div>
          <div class="e-list-c-c" v-if="question_idobj.ques_sub_headings[0]"
            v-html="question_idobj.ques_sub_headings[0].sub_heading"></div>
          <div class="e-list-c-x" v-if="question_idobj.ques_answers">
            <span>答案：</span>
            <p style="display: inline; margin-right: 10px" v-for="(ans, ansi) in question_idobj.ques_answers"
              :key="ansi">
              {{ ans.answer }}
            </p>
          </div>
          </Col>
          <!-- 完形填空 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 10">
          <div class="e-list-c-c" v-html="question_idobj.formatData.stem_src_txt"></div>
          <div v-show="question_idobj.formatData.sub_headings"
            v-for="(setm, i) in question_idobj.formatData.sub_headings" :key="i">
            <div class="e-list-c-c" v-if="setm.options">
              <p v-for="(option, i) in setm.options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option"
                :style="{
                  color: setm.answer.answer == i ? '#e76f74' : '',
                }"></p>
            </div>
            <div class="e-list-c-x">
              <p><span>答案：</span>
                {{ String.fromCharCode(65 + Number(setm.answer.answer)) }}
              </p>
            </div>
          </div>
          </Col>
          <!-- 基础选择题 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 1">
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.sub_heading
          " v-html="question_idobj.formatData.sub_heading"></div>
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.options
          ">
            <p v-for="(option, i) in question_idobj.formatData.options" :key="i"
              v-html="String.fromCharCode(65 + i) + '.' + option.option" :style="{
                color:
                  question_idobj.formatData.answer.answer ==
                    String.fromCharCode(65 + i)
                    ? '#e76f74'
                    : '',
              }"></p>
          </div>
          <div v-show="question_idobj.question_type.batch == 1 &&
            question_idobj.formatData.sub_headings
            " v-for="(setm, i) in question_idobj.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + setm.sub_heading"></div>
            <div class="e-list-c-c" v-if="setm.options">
              <p v-for="(option, i) in setm.options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option"
                :style="{
                  color: setm.answer[0].answer == i ? '#e76f74' : '',
                }"></p>
            </div>
          </div>
          </Col>

          <!-- 多选题 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 12">



          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.sub_heading
          " v-html="question_idobj.formatData.sub_heading"></div>
          <div class="e-list-c-c" v-if="
            question_idobj.question_type.batch == 2 &&
            question_idobj.formatData.options
          ">
            <p v-for="(option, i) in question_idobj.formatData.options" :key="i"
              v-html="String.fromCharCode(65 + i) + '.' + option.option" :style="{
                color:
                  question_idobj.formatData.answer.answer.split(',').includes(String.fromCharCode(65 + i))
                    ? '#e76f74'
                    : '',
              }"></p>
          </div>
          <div v-show="question_idobj.question_type.batch == 1 &&
            question_idobj.formatData.sub_headings
            " v-for="(setm, i) in question_idobj.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + setm.sub_heading"></div>
            <div class="e-list-c-c" v-if="setm.options">
              <p v-for="(option, i) in setm.options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option"
                :style="{
                  color: setm.answer[0].answer == i ? '#e76f74' : '',
                }"></p>
            </div>
          </div>
          </Col>


          <!-- 听力选择题 -->
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 3">
          <div v-if="question_idobj.question_type.batch == 2">
            <div class="e-list-c-b" style="display: flex; padding-bottom: 4px">
              <audio style="width: 180px; height: 30px" v-if="question_idobj.formatData.stem_src_audio" :ref="'audio0'"
                controls :src="question_idobj.formatData.stem_src_audio"></audio>
              <span style="margin-left: 10px" v-if="question_idobj.formatData.stem_src_txt"
                v-html="question_idobj.formatData.stem_src_txt"></span>
            </div>
            <div class="e-list-c-c" v-if="question_idobj.formatData.sub_headings" v-html="question_idobj.formatData.sub_headings[0].sub_heading
              "></div>
            <div class="e-list-c-c" v-if="question_idobj.formatData.sub_headings[0]">
              <p v-for="(option, i) in question_idobj.formatData
                .sub_headings[0].options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option" :style="{
                  color:
                    question_idobj.formatData.sub_headings[0].answer
                      .answer == option.option_k
                      ? '#e76f74'
                      : '',
                }"></p>
            </div>
          </div>
          <div v-show="question_idobj.question_type.batch == 1 &&
            question_idobj.formatData.sub_headings
            " v-for="(stem, i) in question_idobj.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + stem.sub_heading"></div>
            <audio v-if="stem.sub_src_audio" style="width: 180px; height: 34px" :ref="'audioa' + i" controls
              :src="stem.sub_src_audio"></audio>
            <div class="e-list-c-c">
              <p v-for="(option, i) in stem.options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option"
                :style="{
                  color: stem.answer.answer == i ? '#e76f74' : '',
                }"></p>
            </div>
          </div>
          </Col>
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 11"><!-- 写作题 -->
          <!-- <p class="e-list-c-b">作文关键词：<span v-html="question_idobj.formatData.stem"></span></p> -->
          <p class="e-list-c-b">
            字数建议：下限：
            <span v-html="question_idobj.formatData.limit_l"></span>上限：<span
              v-html="question_idobj.formatData.limit_r"></span>
          </p>
          <div class="e-list-c-x">
            <p v-html="question_idobj.formatData.stem"></p>
          </div>
          <div class="e-list-c-x" v-if="question_idobj.formatData.answer">
            <span>答案：</span>
            <p v-html="question_idobj.formatData.answer.answer"></p>
          </div>
          </Col>
          <Col class="e-list-c" v-else-if="question_idobj.question_type.basic_ques_types == 6"><!-- 长篇阅读匹配 -->
          <div v-show="question_idobj.formatData.sub_headings"
            v-for="(setm, i) in question_idobj.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + setm.sub_heading"></div>
            <p v-if="setm.answer">答案：{{ setm.answer[0].answer }}</p>
          </div>
          </Col>
          <Col class="e-list-c" v-else-if="
            question_idobj.question_type.basic_ques_types == '8,9'
          "><!-- 混合题 -->
          <p class="e-list-c-b" v-html="question_idobj.formatData.stem_src_txt"></p>
          <div v-show="question_idobj.formatData.sub_headings"
            v-for="(setm, i) in question_idobj.formatData.sub_headings" :key="i">
            <div class="e-list-c-c dis" v-html="i + 1 + '.' + setm.sub_heading"></div>
            <div class="e-list-c-c" v-if="setm.options">
              <p v-for="(option, i) in setm.options" :key="i" v-html="String.fromCharCode(65 + i) + '.' + option.option"
                :style="{
                  color: setm.answer[0].answer == i ? '#e76f74' : '',
                }"></p>
            </div>
            <div class="e-list-c-x">
              <span>答案：</span>
              <p v-if="setm.options.length == 0 && setm.answer" v-html="setm.answer[0].answer"></p>
              <p v-else>
                {{
                  String.fromCharCode(65 + Number(setm.answer[0].answer))
                }}
              </p>
            </div>
          </div>
          </Col>
          <Col class="e-list-btm">
          试题来源：{{ question_idobj.src_name ? question_idobj.src_name : "未知" }}
          </Col>
          <Col class="e-list-btm">
          解析：{{ question_idobj.ques_analysis[0].analysis || "-" }}
          </Col>
          <Col class="e-list-btm">
          考点：{{ question_idobj.knowledge || "-" }}
          </Col>
        </Row>
        </Col>
      </Row>
      <!-- <Row class="botm">
                <span>分数：<span style="font-size:20px">{{tot_score}}</span></span>
                <Button type="primary" @click="yuejuan">阅卷</Button>
            </Row> -->
      <div v-if="!question_idobj && !questiondata">&nbsp;暂无数据</div>
      </Col>
      <Col span="19" class="blockrow-201" v-if='isshow == 0'>
      <Row class="blockrow-Row" v-if="statendInfo">
        <h2>考生和试卷信息</h2>
        <p v-if='statendInfo.student'>考生ID：{{ statendInfo.student.name }}<span>联系方式：{{ statendInfo.student.mobile
        }}</span>
        </p>
        <p v-if='statendInfo.student'>
          姓名：{{ statendInfo.student.real_name }}<span>学校：{{ statendInfo.student.campus_name }}</span>
        </p>
        <p>进入考试时间：{{ statendInfo.enroll_start_time }}<span>交卷时间：{{ statendInfo.enroll_end_time }}</span></p>

      </Row>
      <Row>
        <div v-if="!statendInfo" style="width:100%;text-align:center;">&nbsp;暂无考生信息</div>
      </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      istrun: true,
      question_idobj: {},
      dataLeft: [],
      statendInfo: {},
      questiondata: [],
      infos: {},
      isshow: 0,
      tot_score: 0,
      countObj: {},
      right: require('@/assets/images/right.png'),
      erro: require('@/assets/images/err.png'),
      coloums: [
        { title: "题目", key: "title", align: "center" },
        { title: "题号", key: "id", align: "center" },
        { title: "本题分数", key: "score", align: "center" },
        { title: "得分", slot: "get_score", align: "center" },
        { title: "对错", slot: "is_right", align: "center" },
        { title: "学生答案", slot: "student_answer", minWidth: 70, align: "center" },
        { title: "参考答案", slot: "answer", minWidth: 70, align: "center" },
      ]
    };
  },
  activated() {
    this.isshow = 0
    this.infos.id = this.$route.query.id
    this.getData(this.$route.query.id);
    this.getleftData(this.$route.query.id);
  },
  methods: {
    changsore(row) {
      this.tot_score = 0
      this.questiondata[row._index].get_score = row.get_score
      for (var i in this.questiondata) {
        this.tot_score += this.questiondata[i].get_score
      }
      this.$forceUpdate();
    },
    yuejuan() {
      var arr = []
      for (var i in this.questiondata) {
        if (!this.questiondata[i].get_score) {
          this.$Message.warning('请先打分后，进行提交!')
          return false
        }
        arr.push({ id: this.questiondata[i].id, get_score: this.questiondata[i].get_score, is_right: this.questiondata[i].is_right })
      }
      this.$axios
        .post(
          "/app/exam_enroll_student/doRate?", { examination_id: this.infos.id, student_id: this.infos.student_id, answer_data: JSON.stringify(arr) })
        .then((res) => {
          if (res.code == 1) { this.$Message.success('阅卷成功') }
        });
    },
    getleftData(id) {
      this.dataLeft = []
      this.countObj = {}
      this.$axios
        .post(
          "/app/exam_enroll_student/partList?examination_id=" + id
        )
        .then((res) => {
          this.dataLeft = this.convert1Tree(res.data.list)
        });
    },
    getData(id) {
      this.statendInfo = {}
      this.$axios
        .get("/app/exam_enroll_student/getStudentInfo?examination_id=" + id)
        .then((res) => {
          if (res.code == 1) {
            this.statendInfo = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            color: data.score == null && data.pi1name ? "#c12a31" : "#333",
            fontSize: data.question_id ? "12px" : "13px",
            width: "100%",
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline",
              },
              style: {
                marginRight: "6px",
              },
            }),
            h("span", data.title),
          ]),
        ]
      );
    },
    leftchange(e) {
      var that = this;
      if (!e || e.length == 0) {
        return false;
      } else if (!e[0].question_num) {
        return false;
      } else {
        this.isshow = 1
        that.getquestion_idobjt(e[0].question_id, e[0].title);
        return false;
      }
    },
    getquestion_idobjt(id, title) {
      if (!id) {
        this.isshow = 0
        this.$Message.warning('暂无数据')
        return false
      }
      this.questiondata = []
      this.question_idobj = {};
      this.$axios
        .get("/app/exam_enroll_student/rightPartKey?question_id=" + id + '&examination_id=' + this.infos.id)
        .then((res) => {
          if (res.code == 1) {
            for (var i in res.data) {
              res.data[i].title = title
              res.data[i].get_score = Number(res.data[i].get_score)
              this.questiondata.push(res.data[i]);
            }
          } else {
            this.$Message.error(res.msg);
          }
        });
      this.$axios
        .get("/app/examination_questions/detail?id=" + id)
        .then((res) => {
          if (res.code == 1) {
            this.question_idobj = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    convert1Tree(tree) {
      const result = [];
      if (tree) {
        tree.forEach((item) => {
          const value = item.id;
          const title = item.name;
          const id = item.id;
          const pid = item.pid;
          let children = item.child;
          // let checked=item.checked;
          const expand = true;
          if (children) {
            children = this.convert2Tree(children, item.name);
          }
          result.push({
            value,
            id,
            pid,
            title,
            children,
            expand,
          });
        });
      } else {
        return [];
      }
      console.log(result)
      return result;
    },
    convert2Tree(tree, name) {
      const result = [];
      if (tree) {
        tree.forEach((item) => {
          const value = item.id;
          const title = item.name;
          const piname = name;
          const id = item.id;
          const pid = item.pid;
          const expand = true;
          if (item.parts) {
            var children = this.convert3Tree(item.parts, piname, item.name);
          }
          // let checked=item.checked;
          result.push({ value, piname, children, expand, id, pid, title });
        });
      } else {
        return [];
      }
      return result;
    },
    convert3Tree(tree, pname, name) {
      const result = [];
      if (tree) {
        tree.forEach((item) => {
          const value = item.id;
          const title = item.name;
          const pi1name = pname;
          const piname = name;
          const id = item.id;
          const question_num = item.question_num;
          const question_id = item.question_id;
          const ques_type_id = item.ques_type_id;
          const score = item.score
          result.push({
            value,
            pi1name,
            piname,
            id,
            question_num,
            question_id,
            ques_type_id, score,
            title,
          });
        });
      } else {
        return [];
      }
      return result;
    },
  },
};
</script>
<style scoped lang="less">
.hisdange .ivu-divider-horizontal.ivu-divider-with-text-left:before,
.hisdange .ivu-divider-horizontal.ivu-divider-with-text-left:after {
  border-top: 1px solid #ccc !important;
}

/deep/ .umb a {
  margin-left: 0 !important;
}

.mels {
  height: 3.8vh;
  margin-top: -1.8vh;
  background: #02a2c7;
  color: #fff;
  padding: 0 2vw;
  font-size: 1.1vw;
  line-height: 4vh;
  display: flex;
  justify-content: space-between;
}

.blockrow {
  margin-top: 0.4vw;
  overflow: auto;

  .blockrow-4 {
    height: 80vh;
    overflow-y: scroll;
    border-right: 1px solid #999;

    a {
      width: 100%;
      display: block;
      border-bottom: 1px solid #ddd;
      line-height: 4vh;
      font-size: 17px;
      font-weight: 600;
      color: #333;

      span {
        font-weight: 400;
      }
    }

    span {
      font-size: 17px;
      font-weight: 600;
    }
  }

  .blockrow-20 {
    position: relative;
    height: 80vh;
    overflow: auto;

    p {
      line-height: 4vh;
      padding: 0 1vw;
    }
  }

  .blockrow-201 {
    .blockrow-Row {
      display: block;
    }

    h2 {
      padding: 1vw 1vw 0;
    }

    p {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
      line-height: 4vh;
      padding: 0 2vw;
      font-size: 1vw;

      span {
        display: inline-block;
        width: 45%;
      }
    }
  }

  .e-list {
    display: block;
    background: #fff;
    margin-top: 10px;
    padding: 6px 0;
    border-radius: 8px;
    border: 1px solid #eee;

    /deep/ input {
      border: none;
      border-bottom: 1px solid #999;
      min-width: 80px;
      width: 80px;
      padding: 4px 5px 0;
      line-height: 0.9;
    }

    .e-list-top {
      border-bottom: 1px solid #eee;
      padding: 0px 14px 4px;
      display: flex;
      justify-content: space-between;

      .left {
        color: #000;
        font-weight: 600;
        font-size: 13px;
        width: 90%;

        span {
          margin-right: 14px;
        }
      }

      .right {
        width: 10%;

        a {
          font-size: 12px;
          margin-left: 14px;
        }
      }
    }

    .e-list-c {
      padding: 4px 14px 0;
      overflow: hidden;

      .e-list-c-b {
        border-bottom: 1px solid #eee;
        font-size: 13px;
        // text-overflow: -o-ellipsis-lastline;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 2;
        // line-clamp: 2;
        // -webkit-box-orient: vertical;
        color: #555;
        font-weight: 600;
        line-height: 1.8;
      }

      .dis {
        display: flex;
      }

      .e-list-c-c {
        // display: flex;
        font-size: 13px;
        line-height: 1.8;
        color: #444;

        p {
          width: 98%;
          display: flex;
          margin-right: 1%;
          line-height: 1.8;
          // white-space:nowrap;
          // overflow:hidden;
          // text-overflow:ellipsis;
          align-items: center;

          /deep/ p {
            display: flex;
            align-items: center;
          }
        }
      }

      .e-list-c-x {
        font-size: 13px;
        margin: 4px 0 10px;
        color: #666;
        display: flex;

        span {
          color: #333;
          font-weight: 600;
        }

        p {
          width: 94%;
          line-height: 1.6;
          // white-space:nowrap;
          // overflow:hidden;
          // text-overflow:ellipsis;
        }
      }
    }

    .e-list-btm {
      padding: 4px 14px 0;
      border-top: 1px solid #eee;
      color: #999;
      display: flex;
      justify-content: space-between;
      font-size: 13px;
    }
  }

  .botm {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 10px;
    align-items: center;
  }
}

/deep/ .ivu-menu-light {
  background: none;
}

/deep/ .ivu-table-cell {
  padding: 0;
}
</style>
